import { Injectable, signal } from '@angular/core';

/**
 * Bruggetje zodat de (generieke, contextloze) doc-viewer de poort-detailinfo van
 * de ACTIEVE chart kan openen. De kanaal-documentweergave toont bovenaan twee
 * poort-blokjes; een klik daarop moet dezelfde poort-info tonen als een klik op
 * die poort in de chart. De doc-viewer heeft echter geen chart-context, dus de
 * chart-pagina registreert hier haar opener (net als de print-handler in de
 * app-shell) en de doc-viewer roept hem aan. Zo blijft de doc-viewer losgekoppeld
 * van de chart.
 */
@Injectable({ providedIn: 'root' })
export class HdDocGateOpenerService {
  /** Door de actieve chart-pagina geregistreerde opener (null = geen chart actief). */
  readonly openGate = signal<((gate: number) => void) | null>(null);
}
